import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const davisIslandsConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Davis Islands Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Davis Islands, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_davis_islands',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Davis Islands',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Davis Islands Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the 
     premier waterfront properties of <strong>Davis Islands</strong>. This 
     iconic Tampa neighborhood sits surrounded by water on all sides 
     meaning every tree here faces constant salt air exposure, tidal winds, 
     and direct storm impact from Tampa Bay. Premium homes on tight island 
     lots demand precision work, and our team delivers exactly that.`,

    `We specialize in <strong>high-care tree removal and trimming on waterfront 
     island properties</strong> large overhanging limbs near luxury homes 
     and seawalls, salt compromised palms and hardwoods, storm damaged trees 
     requiring careful rigging in tight spaces, and canopy reductions that 
     eliminate risk without disrupting the beauty of your landscape.`,

    `<strong>Sam's Tree Service</strong> provides trusted, professional tree care 
     throughout <strong>Davis Islands</strong> and the surrounding 
     <strong>South Tampa waterfront</strong> protecting the value and safety 
     of your island property all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Davis Islands, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_DavisIslands = () => <LocationPage config={davisIslandsConfig} />;
export default Services_DavisIslands;
